import { Injectable, inject } from '@angular/core';
import {
  Router,
  UrlTree,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthProvider } from '../../features/auth/shared/auth-provider';
import { RoleMenusProvider } from '../security/role-menus-provider';

/**
 * AdminPermissionGuard — control de acceso fino a /panel/*.
 *
 * Complementa a AuthGuard (sesión) con el permiso por línea de menú: la
 * política vive en el árbol de menús del rol (GET /account/roles/menus,
 * caché de sesión en RoleMenusProvider), no en el nombre del rol.
 * Superadmin siempre entra. Sin sesión → /login; autenticado sin permiso
 * sobre la ruta solicitada → /403 (LayoutStatusView).
 */
@Injectable({ providedIn: 'root' })
export class AdminPermissionGuard implements CanActivate {
  private readonly auth = inject(AuthProvider);
  private readonly roleMenus = inject(RoleMenusProvider);
  private readonly router = inject(Router);

  async canActivate(
    _route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean | UrlTree> {
    await this.auth.notifier.ensureSessionValidated();
    const auth = this.auth.state();
    if (!auth.isAuthenticated) {
      return this.router.createUrlTree(['/login']);
    }
    if (auth.isSuperadmin) return true;
    await this.roleMenus.notifier.ensureLoaded();
    if (this.roleMenus.notifier.canAccess(state.url)) return true;
    return this.router.createUrlTree(['/403']);
  }
}
